/**
 *  NYOMTATÁS ELŐNÉZETTEL
 *
 *  Az asztali programban (Electron, Windows 11) a nyomtatás a Windows saját nyomtatóablakát nyitja, és
 *  annak az előnézeti része üres: „Ez az alkalmazás nem támogatja a nyomtatási képet” – a Windows-ablak
 *  előnézetét csak a Windows saját nyomtatási felületét használó program tudja kitölteni (user, 2026-11-03).
 *  Ezért ott a kész dokumentumból PDF készül (a lapmérettel, margóval, laptörésekkel, ahogy papírra
 *  menne), és egy előnézeti ablakban nyílik meg – abból a PDF-néző nyomtató gombjával nyomtatható.
 *  Böngészőben marad a böngésző saját nyomtatási előnézete.
 *
 *  A híd (window.cronomitNyomtato.elonezet) az asztali program főablakának preloadjában van
 *  (electron/fo-preload.js → electron/nyomtato.js); régebbi asztali programban nincs, ott a régi út megy.
 */

function hid(): ((f: { html: string; cim: string; alap: string }) => Promise<any>) | null {
  const h = (window as any).cronomitNyomtato;
  return h && typeof h.elonezet === 'function' ? h.elonezet : null;
}

/** Van-e PDF-előnézet (asztali program). */
export function vanPdfElonezet(): boolean { return !!hid(); }

/** Kész HTML-dokumentum előnézete / nyomtatása. Asztali programban PDF-előnézet; különben `tartalek()` (a böngésző nyomtatása). */
export function htmlElonezet(html: string, cim: string, tartalek: () => void): void {
  const h = hid();
  if (!h) { tartalek(); return; }
  h({ html, cim, alap: location.origin + '/' }).then((r: any) => { if (r && r.ok === false) tartalek(); }, () => tartalek());
}

/** Egy (rejtett keretben vagy felugró ablakban) megírt dokumentum nyomtatása előnézettel. */
export function ablakNyomtat(w: Window, cim?: string): void {
  const d = w.document;
  htmlElonezet('<!doctype html>\n' + d.documentElement.outerHTML, cim || d.title || 'Nyomtatás', () => { w.focus(); w.print(); });
}
